module.exports = __webpack_public_path__ + "static/media/caterbowl1.90f02a5d.png";